import React from 'react'
import Hero from '../components/Consumer/Hero'
import ValueProposition from '../components/Consumer/ValueProposition'
import Features from '../components/Consumer/Features'
import Testimonials from '../components/Consumer/Testimonials'
import CTA from '../components/Consumer/CTA'
import Footer from '../components/Consumer/Footer'
import Pricing from '../components/Consumer/Pricing'
import WhatsappButton from '../components/Consumer/WhatsAppFloatingButton'

import NewHero from '../components/Consumer/NewHero'
import HowItWorks from '../components/Consumer/HowItWorks'
import WhyZafflo from '../components/Consumer/WhyZafflo'
import FeatureHighlights from '../components/Consumer/FeatureHighlights'
import SocialProof from '../components/Consumer/SocialProof'
import WhyZaffloWins from '../components/Consumer/WhyZaffloWins'
import PricingCTA from '../components/Consumer/PricingCTA'
import PremiumLandingPage from '../components/Consumer/PremiumLandingPage'
import NewHero2 from '../components/Consumer/NewHero2'


function ConsumerPage() {
  return (
    <div id="Home" className="font-lato">
      <NewHero2 />
    <HowItWorks/>
    <WhyZafflo/>
      {/* <FeatureHighlights/>*/}
     <SocialProof/>
   {/* <WhyZaffloWins/>*/}
     <PricingCTA/>
   {/* <ValueProposition /> 
    <Features />
   <Testimonials />
   <Pricing/> */}
    <CTA />
    <Footer />
    <WhatsappButton/>
  </div>
  )
}

export default ConsumerPage
